function createFederationInjector(parentInjector) {
  const providesInternal = /* @__PURE__ */ new Map();
  const provides = /* @__PURE__ */ new Map();
  const injector = {
    __internal: {
      inject: injectInternal,
      provide: provideInternal,
      fork
    },
    inject,
    provide
  };
  return injector;
  function provideInternal(key, service) {
    providesInternal.set(key, service);
  }
  function injectInternal(key, options) {
    if (providesInternal.has(key)) {
      return providesInternal.get(
        key
      );
    } else if (provides.has(key)) {
      return provides.get(
        key
      );
    } else if (parentInjector) {
      return parentInjector.__internal.inject(key, options);
    } else if (options && "defaultValue" in options) {
      return options.defaultValue;
    }
    throw new Error(`Missing dependency: ${key.toString()}`);
  }
  function inject(key, options) {
    if (provides.has(key)) {
      return provides.get(key);
    } else if (parentInjector) {
      return parentInjector.inject(key, options);
    } else if (options && "defaultValue" in options) {
      return options.defaultValue;
    }
    throw new Error(`Missing dependency: ${key.toString()}`);
  }
  function provide(key, service) {
    provides.set(key, service);
  }
  function fork() {
    return createFederationInjector(injector);
  }
}
function useFederationInjector() {
  return createFederationInjector();
}
export {
  useFederationInjector as u
};
//# sourceMappingURL=injector.js.map
